export function leadingSlash (str) {
  return str.startsWith('/') ? str : '/' + str
}

export function trailingSlash (str) {
  return str.endsWith('/') ? str : str + '/'
}

export const wait = timeout => {
  return new Promise(resolve => setTimeout(resolve, timeout))
}

export const filterData = (data, query) => {
  return data.filter(item => item.id.includes(query))
}

export const indexes = (data, query) => {
  return data.reduce((acc, el, i) => (el.id.includes(query) ? [...acc, i] : acc), [])
}
